import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { NavController, MenuController, AlertController } from '@ionic/angular';
import { EnumAppMenu } from '@models/AppMenus';
import { MaintenanceService } from '@services/maintenance.service';
import { SessionService } from '@services/session.service';

export const MaintenanceGuard: CanActivateFn = async (route, state) => {

    const maintenanceService = inject(MaintenanceService);
    const sessionService = inject(SessionService);
    const navController = inject(NavController);
    const alertController = inject(AlertController);
    const menuController = inject(MenuController);

    // Obtém as informações de manutenção para a plataforma "Backoffice"
    const info = await maintenanceService.GetCacheMaintenanceInfo('Backoffice');

    debugger

    if (!info) return true;

    if (info.UnderMaintenance) {
        menuController.enable(false);

        navController.navigateRoot([EnumAppMenu.Maintenance]);
        // alertController.dismiss();
    } else if (state.url.includes(EnumAppMenu.Maintenance)) {
        const hasSession = sessionService?.HasSession();
        navController.navigateRoot([hasSession ? EnumAppMenu.Dashboard : EnumAppMenu.Login]);
    }


    return true;
};
